<template>
<div class="chapter">
<div class="inner_page">
<div class="section" id="calibre_pb_0">
<div class="figcenter" id="il_1">
<img alt=" " class="calibre4" id="id-6117728965484537125" src="OEBPS/Images/3757041487943700252_i_001.jpg"/>
<div class="caption">A password was what he wanted, and Mr. Poincaré had forgotten
to give me the correct one
</div>
</div>
<div class="calibre3"> </div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section003.vue?7cfb04d6